module.exports = __webpack_public_path__ + "static/media/chevron-right.dc1b6796.svg";